import React, {useEffect, useState} from "react";
import {LoggedInView} from "../common/LoggedInView";
import {Link, useNavigate, useParams} from "react-router-dom";
import {BreadcrumbLink} from "../../models/BreadcrumbLink";
import Breadcrumbs from "../common/Breadcrumbs";
import ElogInput from "../common/form/ElogInput";
import {createVendorContact} from "../../store/reducers/VendorContactsSlice";
import {RequestStatus} from "../../utils/Enums";
import {useAppDispatch, useAppSelector} from "../../utils/Hooks";
import {resetCreateVendorStatus} from "../../store/reducers/VendorsSlice";
import ElogTextarea from "../common/form/ElogTextarea";
import CategoryType from "../../models/CategoryType";
import {apiClient} from "../../utils/ApiClient";
import {useFormik, Field, Form, FormikProvider} from "formik";
import {updateOfflineReason} from "../../store/reducers/OfflineReasonsSlice";
import ElogSelect, {Option} from "../common/form/ElogSelect";
import Category from "../../models/Category";
import {EXCLUSION_CATEGORY_TYPE} from "../../utils/Constants";

interface CreateVendorContactScreenProps {
}

export interface CreateVendorContactFormProps {
    name: string;
    plea: string;
    email: string;
    phone: string;
    comment?: string;
    groups: string[];
}

export const NewVendorContactScreen: React.FC<CreateVendorContactScreenProps> = () => {

    const dispatch = useAppDispatch();
    const navigate = useNavigate();

    const {vendorId} = useParams<{ vendorId: string }>();

    const vendorContactsState = useAppSelector((state) => state.vendorContacts);

    const requestStatus: RequestStatus = vendorContactsState.createVendorContactStatus;

    const breadcrumbLinks: BreadcrumbLink[] = [
        {text: "Hankijad", url: "/vendors"},
        {text: "Hankija kontaktid", url: `/vendors/${vendorId}/contacts`},
        {text: "Lisa uus hankija kontakt", url: `/vendors/${vendorId}/contacts/create`},
    ];

    const languageOptions: Option[] = [
        {value: 'est', label: 'Eesti'},
        {value: 'eng', label: 'Inglise'},
        //{value: 'fin', label: 'Soome'},
        //{value: 'swe', label: 'Rootsi'},
    ];

    const [categoryTypes, setCategoryTypes] = useState<CategoryType[]>([]);
    const [exclusionCategories, setExclusionCategories] = useState<Category[]>([]);

    useEffect(() => {
        if (requestStatus === RequestStatus.Success) {
            dispatch(resetCreateVendorStatus());
            navigate(breadcrumbLinks[1].url);
        }
    }, [requestStatus]);

    useEffect(() => {

        apiClient.get("category-types/all-by-vendor/" + vendorId).then((response) => {
            setCategoryTypes(response.data);
        });

        apiClient.get("category-types/all-by-category").then((response) => {

            response.data.map((categoryType: CategoryType) => {

                if ( categoryType.id === EXCLUSION_CATEGORY_TYPE ) {
                    setExclusionCategories(categoryType?.categories ?? []);
                }

            })

        });

    }, []);

    // @ts-ignore
    const formik = useFormik({
        initialValues: {
            emails: ['']
        },
        onSubmit: (values: any) => {
            if (vendorId) {
                dispatch(createVendorContact({vendorId:parseInt(vendorId, 10), vendorContactData: values}));
            }
        },
        enableReinitialize: true
    });

    const {values, setFieldValue, handleSubmit} = formik;

    return (
        <LoggedInView fullWidth={false}>
            <Breadcrumbs links={breadcrumbLinks}/>
            {requestStatus === RequestStatus.Failed && vendorContactsState.errors.length > 0 && (
                <div className="message msg-error">
                    <div>
                        <h2>Viga:</h2>
                        {vendorContactsState.errors.map((error, index) => (
                            <span key={index}>{error}<br /></span>
                        ))}
                    </div>
                </div>
            )}
            <FormikProvider value={formik}>
                <Form onSubmit={handleSubmit}>
                    <div className="form">
                        <h2>
                            <span>Hankija kontakti andmed</span>
                        </h2>
                        <table className="form">
                            <tbody>
                            <ElogInput label="Nimi" name="name" mandatory={true}/>
                            <ElogInput label="Pöördumine" name="plea" mandatory={true}/>
                            {values.emails.map((email, index) => (
                                <>
                                    <ElogInput
                                        label={`E-mail ${index + 1}`}
                                        name={`emails.${index}`}
                                        type="email"
                                        mandatory={true}
                                        button={index > 0 && (
                                            <button
                                                style={{color: 'red'}}
                                                type="button"
                                                onClick={() => setFieldValue('emails', values.emails.filter((_, i) => i !== index))}
                                            >
                                                [X]
                                            </button>
                                        )}
                                    />
                                </>
                            ))}
                            <tr>
                                <th>
                                </th>
                                <td>
                                    <button
                                        type="button"
                                        onClick={() => setFieldValue('emails', [...values.emails, ''])}
                                    >
                                        Lisa
                                    </button>
                                </td>
                            </tr>
                            <ElogInput label="Telefon" name="phone" mandatory={true}/>
                            <ElogInput label="Teams" name="skype" mandatory={false}/>
                            <ElogInput label="Whatsapp" name="whatsapp" mandatory={false}/>
                            <ElogTextarea label="Taustainfo" name="comment"/>
                            <ElogSelect label="Keel" name="language" options={languageOptions} mandatory={true}/>
                            </tbody>
                        </table>
                    </div>

                    {categoryTypes.map((categoryType) => (
                        <div key={categoryType.id} className="form">
                            <h2>
                                <span>{categoryType.name}</span>
                            </h2>
                            {categoryType?.categories?.map((category) => (
                                <Field
                                    key={category.id}
                                    name="groups"
                                    type="checkbox"
                                    value={String(category.id)}
                                    render={(props: { field: { value: any; onChange: (e: React.ChangeEvent<any>) => void; onBlur: () => void; name: string } }) => (
                                        <>
                                            <label htmlFor={`group_${category.id}`}>{category.name}</label>
                                            <input
                                                {...props.field}
                                                id={`group_${category.id}`}
                                                type="checkbox"
                                                onChange={(event) => props.field.onChange(event)}
                                                onBlur={() => undefined}
                                            />
                                        </>
                                    )}
                                />
                            ))}
                        </div>
                    ))}
                    {/*
                    <br /><hr />
                    <div className="form">
                        <h2>
                            <span>Välistused</span>
                        </h2>
                        {exclusionCategories?.map((category) => (
                            <Field
                                key={'exclude' + category.id}
                                name="exclude"
                                type="checkbox"
                                value={String(category.id)}
                                render={(props: { field: { value: any; onChange: (e: React.ChangeEvent<any>) => void; onBlur: () => void; name: string } }) => (
                                    <>
                                        <label htmlFor={`exclude_${category.id}`}>{category.name}</label>
                                        <input
                                            {...props.field}
                                            id={`exclude_${category.id}`}
                                            type="checkbox"
                                            onChange={(event) => props.field.onChange(event)}
                                            onBlur={() => undefined}
                                        />
                                    </>
                                )}
                            />
                        ))}
                    </div>
                    */}

                    {requestStatus === RequestStatus.Success && (
                        <div className="message msg-ok">
                            <div>
                                <h2>Kontakti andmed uuendatud</h2>
                            </div>
                        </div>
                    )}
                    {requestStatus === RequestStatus.Failed && vendorContactsState.errors.length > 0 && (
                        <div className="message msg-error">
                            <div>
                                <h2>Viga:</h2>
                                {vendorContactsState.errors.map((error, index) => (
                                    <span key={index}>{error}<br/></span>
                                ))}
                            </div>
                        </div>
                    )}

                    <div className="action clear">
                        <p>
                            <button type="submit">
                                  <span>
                                    <strong>Salvesta</strong>
                                  </span>
                            </button>
                            <Link to={`/vendors/${vendorId}/contacts`}>Tühista</Link>
                        </p>
                    </div>
                </Form>
            </FormikProvider>
        </LoggedInView>
    );
};